import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import useAuth from '@/hooks/useAuth'
import { isLocationScoped } from '@/lib/locationScope'
import PermissionRequired from '@/pages/403'

/**
 * The frontend half of the fail-closed location-scope gate
 * (location-scoped-member-role). A location member (site manager, tenant)
 * reaches only routes marked `locationScopeAware`; any other route renders the
 * 403 page, or redirects to `redirectTo` when the route names one (the home
 * page sends them to their Power overview). Everyone else passes through.
 */
const LocationScopeGuard = ({ aware, redirectTo, children }) => {
    const { user } = useAuth()

    if (!aware && isLocationScoped(user)) {
        if (redirectTo) {
            return <Navigate to={redirectTo} replace />
        }
        return <PermissionRequired />
    }

    return <>{children}</>
}

LocationScopeGuard.propTypes = {
    aware: PropTypes.bool,
    redirectTo: PropTypes.string,
    children: PropTypes.node
}

export default LocationScopeGuard
